import { Component } from "@angular/core";
import { environment } from "@env/environment";
import { AppService } from "./app.service";

@Component({
  selector: "sorteo-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  env = environment;

  constructor(public service: AppService) {}
}
